import styled from "styled-components";

export const CMWizardModal = styled.div((props) => ({
  width: "100%",  
  maxWidth: "720px",  
  minWidth: "320px", 
  maxHeight:"90%",
  backgroundColor: "white",
  borderRadius: "8px",
  boxSizing: "border-box",

  [`@media (min-width: 2000px)`]: {
    maxWidth: "70%",
    //width:"auto",
    height: "auto",   
    "& > div > svg": {
    width: "2vh",
    height: "2vh",
  },
   },
  
  "& > div > div": {
    width: "100%",
  },

  height: "auto", 
  overflow: "auto", 

  [`@media ${props.theme.breakpoints.lg}`]: {
    //height: "600px ",
    overflow: "auto",
    maxWidth: "720px",  
    minWidth: "480px", 
  },

  [`@media ${props.theme.breakpoints.md}`]: {
    maxWidth: "90%", 
    minWidth: "320px",  
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    maxWidth: "100%", 
    minWidth: "320px",  
    minHeight: "100%",  
    overflowY: "auto",  
  },
}));
